export { default as CustomerLists } from './containers/CustomerContainer'



// WEBPACK FOOTER //
// ./src/CustomerLists/index.js